/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconArrowDownLongBold extends React.Component {
  render() {
    const iconClasses = classNames(
      "icon arrow-down-long-bold",
      this.props.className
    );
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 14.035156 1.9648438 C 12.930156 1.9648438 12.035156 2.8598438 12.035156 3.9648438 L 12.035156 18.964844 L 7.9648438 18.964844 C 7.5608438 18.964844 7.1950156 19.206078 7.0410156 19.580078 C 6.8850156 19.954078 6.9718125 20.384875 7.2578125 20.671875 L 14.328125 27.742188 C 14.719125 28.133187 15.351187 28.133187 15.742188 27.742188 L 22.814453 20.671875 C 23.005453 20.480875 23.107422 20.224844 23.107422 19.964844 C 23.107422 19.835844 23.08225 19.704078 23.03125 19.580078 C 22.87725 19.206078 22.511422 18.964844 22.107422 18.964844 L 18.035156 18.964844 L 18.035156 3.9648438 C 18.035156 2.8598438 17.140156 1.9648438 16.035156 1.9648438 L 14.035156 1.9648438 z" />
      </svg>
    );
  }
}

IconArrowDownLongBold.defaultProps = {
  className: null
};

IconArrowDownLongBold.propTypes = {
  className: PropTypes.string
};

export default IconArrowDownLongBold;
